module.exports = __webpack_public_path__ + "img/send-all-nothing.59fefa20.png";